import { fetchAuthSession } from 'aws-amplify/auth';

export type IdTokenClaims = Record<string, unknown>;

const decodeJwtPayload = (token: string): IdTokenClaims => {
  try {
    const payload = token.split('.')[1];
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
    return JSON.parse(atob(padded)) as IdTokenClaims;
  } catch {
    return {};
  }
};

export const getIdTokenClaims = async (): Promise<IdTokenClaims> => {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken;
  if (!idToken) {
    return {};
  }

  const payload = (idToken as { payload?: IdTokenClaims }).payload;
  if (payload) {
    return payload;
  }

  return decodeJwtPayload(idToken.toString());
};

export const isAdminUser = (claims: IdTokenClaims): boolean => {
  const groupsValue = claims['cognito:groups'];
  const groups = Array.isArray(groupsValue)
    ? groupsValue.map((group) => `${group}`.trim())
    : `${groupsValue ?? ''}`
        .split(',')
        .map((group) => group.trim())
        .filter(Boolean);

  return groups.includes('admin');
};
